import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { OpeningHoursComponent } from "../../../../static/opening-hours/opening-hours.component";

@Component({
    selector: 'app-base-cards-opening-hours',
    imports: [
    CommonModule,
    MatIcon,
    OpeningHoursComponent
],
    templateUrl: './base-cards-opening-hours.component.html',
    styleUrl: './base-cards-opening-hours.component.scss'
})
export class BaseCardsOpeningHoursComponent {
  
  constructor( ) { }

}
